import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer-content" }
const _hoisted_2 = { class: "footer-links" }
const _hoisted_3 = { class: "footer-copyright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "footer-logo" }, "Evelina Lodi", -1)),
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/packages" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Packages", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/portfolio" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Portfolio", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/contact" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Contact", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("p", _hoisted_3, "© " + _toDisplayString(_ctx.currentYear) + " Evelina Lodi Photography. All Rights Reserved.", 1)
  ]))
}